module.exports = __webpack_public_path__ + "static/media/AR.71bee31f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/AR.svg
// module id = 192
// module chunks = 0